import React, { useEffect, useState, useRef } from 'react';
import { array, bool, func } from 'prop-types';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import useWindowSize from '../../../hooks/useWindowSize';

import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import GridAggregateSelector from '../../../components/GridAggregateSelector';
import ScoreSensorSelect from '../../../components/ScoreSensorSelect';
import RuleTotalsPanel from '../../../components/RuleTotalsPanel';
import BobActionMenu from '../../../components/BobActionMenu';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import TabViewSelector from '../../../components/TabViewSelector';
import BobModal from '../../../components/BobModal';
import DeleteSensorModal from '../EquipmentPage/DeleteSensorModal';
import ScoresPanel from './ScoresPanel';
import ScoreGrid from './ScoreGrid';
import SensorConfigurationView from './SensorConfigurationView';
import { getTimeZoneAbbr } from '../../../helpers/timezones';
import NoSelectedSensorsScreen from '../../../components/NoSelectedSensorsScreen';
import ExportDataModal from '../Modals/ExportDataModal';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import PreviewSensorModal from '../Modals/PreviewSensorDataModal';
import BooleanCellFilter from '../../../components/CustomFilters/BooleanCellFilter';
import SensorScoreAggregateFooterCell from '../../../components/SensorScoreAggregateFooterCell';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';
import FormulaGridColumnModal from '../../../components/FormulaGridColumnModal';
import RulesScoreGrid from '../../../components/ScoringGrids/RulesScoreGrid';
import { getActiveViewName } from '../Navigation/NavigationHelper';
import GraphViewSelector from '../../../components/GraphViewSelector';

import { exportImage, Image, geometry,Text } from '@progress/kendo-drawing';
import { saveAs } from '@progress/kendo-file-saver';
import moment from 'moment';
import _, { cloneDeep, isEmpty, isNil, sortBy } from 'lodash';
import { Grid, GridNoRecords, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import {Operators, TextFilter, NumericFilter, DateFilter, BooleanFilter} from '@progress/kendo-react-data-tools';
import { process as kendoProcess, filterBy } from '@progress/kendo-data-query';
import ConditionalFormatModal from '../Modals/ConditionalFormatModal';
import queryString from 'query-string';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';

import {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTooltip,
    ChartTitle,
    ChartPanes,
    ChartPane,
    exportVisual
} from '@progress/kendo-react-charts';
import FilterPanel from '../../../components/K2AFilterControl/FilterPanel';

import BobChartTypeMenu from '../EquipmentPage/BobChartTypeMenu';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import TextField from '@material-ui/core/TextField';
import RawDataTable from '../../../components/RawDataTable/RawDataTable';

import * as ArchitectActions from '../../../actions/architectActions';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as DeviceActions from '../../../actions/deviceActions';
import * as ConfigurationActions from '../../../actions/configurationActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './SensorPanel.module.css';

const initialDataStateFilter = {
    logic:   'and',
    filters: []
};

const initialSensorGridDataState = {
    sort:   [],
    filter: initialDataStateFilter
};

const initialOverviewGridDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const rulesGridColumns = [{name: 'ruleName', label: 'Rule', filter: TextFilter, operators: Operators.text}, {name: 'score', label: 'Score', filter: NumericFilter, operators: Operators.numeric}];
const statusCellFilterValues = [{ text: 'Calculation', operator: 'eq', value: true }, { text: 'Device Object', operator: 'eq', value: false }];
const defaultItem = { text: '(All)', value: undefined };
const DeviceObjectCellFilter = (props, selectedBooleanFilter, setSelectedBooleanFilter) => {
    return (
        <BooleanCellFilter
            {...props}
            data={statusCellFilterValues}
            defaultItem={defaultItem}
            filterValue={selectedBooleanFilter}
            setFilterValue={setSelectedBooleanFilter}
        />
    );
};

const SensorPanel = ({
    activeConfiguration,
    activeTab,
    activeNavCompany,
    activeNavEquipment,
    activeNavSite,
    allSensors,
    allSensorsMeta,
    axes,
    bobLoading,
    clearEntitySensorData,
    companyInfo,
    currentUser,
    dashboardEndTimeStamp,
    dashboardIsCurrentTimeStamp,
    dashboardStartTimeStamp,
    deleteSensorModalOpen,
    desiredInterval,
    entityScoringData,
    entitySensorData,
    exportTableData,
    faultOverlay,
    fetchConfigurations,
    fetchDeviceObjects,
    fetchEntitySensorData,
    fetchEntitySensors,
    fetchFaultOverlay,
    formulaGridColumns,
    healthscoreRawData,
    healthscoreRawDataMeta,
    history,
    handleToggleDeleteSensorModal,
    handleToggleSubscribeToEquipmentAlertsModal,
    isActive,
    isClearAppliedConfiguration,
    newConfiguration,
    rawUnits,
    refreshRawDataGrid,
    refreshTab,
    resetCalculatedSensor,
    redirection,
    saveConfiguration,
    setRefreshTab,
    selectedRule,
    selectedRuleSensors,
    selectedSensors,
    selectedWeatherSensors,
    sensors,
    sensorsMeta,
    setAxes,
    setActiveConfiguration,
    setDeviceObjects,
    setFormulaGridColumns,
    setIsClearAppliedConfiguration,
    setRedirection,
    setRefreshRawDataGrid,
    setSensorConfiguration,
    setDashboardEndTimestamp,
    setDashboardStartTimestamp,
    setFaultOverlay,
    setSelectedSensor,
    setWorkBookMode,
    setSelectedRule,
    setSelectedRuleSensors,
    setSelectedSensors,
    setSelectedWeatherSensors,
    system,
    updateSensor,
    updateTimeStamp,
    updateConfiguration,
    updateConfigurationData,
    workbookModeEnabled,
    ...props
}) => {
    const [view, setView] = useState('');
    const [sensor, setSensor] = useState(null);
    const [sensorGridData, setSensorGridData] = useState([]);
    const [columnNames, setColumnNames] = useState([]);
    const [exportColumnNames, setExportColumnNames] = useState([]);
    const [sensorGraphHeight, setSensorGraphHeight] = useState('60vh');
    const [tableSensors, setTableSensors] = useState([]);
    const [numericDataSet, setNumericDataSet] = useState([]);
    const [overlayData, setOverlayData] = useState([]);
    const [booleanDataSet, setBooleanDataSet] = useState([]);
    const [axis, setAxis] = useState([]);
    const [ganttDs, setGanttDs] = useState([]);
    const [ganttAxisMax, setGanttAxisMax] = useState(0);
    const [ganttAxisMin, setGanttAxisMin] = useState(0);
    const { Rect, Point, Size } = geometry;
    const queryValues = queryString.parse(history.location.search);
    const chart = React.createRef();
    const zoomLevel100 = matchMedia('(min-resolution: 1dppx)');
    const zoomLevel125 = matchMedia('(min-resolution: 1.25dppx)');
    const propFunc = {};
    const [showModal, setShowModal] = useState(false);
    const [formatObj, setFormatObj] = useState({});
    const [formatList, setFormatList] = useState([]);
    const [formatKey, setFormatKey] = useState('');
    const [formatType,setFormatType] = useState('');
    const _export = React.useRef(null);
    const [refresh, doRefresh] = useState(0);
    const [chartType, setChartType] = useState('Line');
    const [scoreChartType, setScoreChartType] = useState('Rules');
    const styleMap = {
        'yellow-cell': {background: '#ffefaf',color: '#783f05'},
        'green-cell':  {background: '#b7e1cd',color: '#274e13'},
        'grey-cell':   {background: '#d9d9d9',color: '#434343'},
        'red-cell':    {background: '#fcd6d6',color: '#85200c'}
    };
    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [previewDataModalOpen, setPreviewDataModalOpen] = useState(false);

    const [aggregateType, setAggregateType] = useState('None');
    const [configuration, setConfiguration] = useState({});
    const [sensorGridDataState, setSensorGridDataState] = useState(initialSensorGridDataState);
    const [sensorGridFilterText, setSensorGridFilterText] = useState('');
    const [sensorGridFields, setSensorGridFields] = useState([]);
    const [selectedSystemRule, setSelectedSystemRule] = useState({});
    const [scoreGridDataState, setScoreGridDataState] = useState(initialSensorGridDataState);
    const [scoreGridFilterText, setScoreGridFilterText] = useState('');
    const [scoreGridFilter, setScoreGridFilter] = useState(initialDataStateFilter);
    const [scoreGridFields, setScoreGridFields] = useState([]);
    const [ruleGridDataState, setRuleGridDataState] = useState(initialSensorGridDataState);
    const [ruleGridFilterText, setRuleGridFilterText] = useState('');
    const [ruleGridFilter, setRuleGridFilter] = useState(initialDataStateFilter);
    const [ruleGridFields, setRuleGridFields] = useState(rulesGridColumns);
    const [ruleGraphGridDataState, setRuleGraphGridDataState] = useState(initialSensorGridDataState);
    const [ruleGraphGridFilterText, setRuleGraphGridFilterText] = useState('');
    const [ruleGraphGridFilter, setRuleGraphGridFilter] = useState(initialDataStateFilter);
    const [ruleGraphGridFields, setRuleGraphGridFields] = useState(rulesGridColumns);

    const [formulaCellModalOpen, setFormulaCellModalOpen] = useState(false);
    const [formulaColumns, setFormulaColumns] = useState([]);
    const [formulaColumnIndex, setFormulaColumnIndex] = useState(0);
    const [formulaValues, setFormulaValues] = useState(null);
    const [currentFormula, setCurrentFormula] = useState(null);
    const [selectedBooleanFilter, setSelectedBooleanFilter] = useState(defaultItem);
    const [exportRawData, setExportRawData] = useState(false);
    const [rules, setRules] = useState([]);
    const [viewKey, setViewKey] = useState('');
    const [overviewGridDataState, setOverviewGridDataState] = useState(initialOverviewGridDataState);
    const [overviewGridTake, setOverviewGridTake] = useState(10);
    const [pageable] = useState({ pageSizes: true });
    const [overviewNameColumnWidth, setOverviewNameColumnWidth] = useState(300);

    const [resetCalculationModalOpen, setResetCalculationModalOpen] = useState(false);
    const [resetCalculationEntity, setResetCalculationEntity] = useState({});
    const [startValue, setStartValue] = useState(0);

    const overviewGridDivRef = useRef(null);
    const overviewGridRef = useRef(null);
    const sensorGridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        if (overviewGridRef.current) {
            const columns = overviewGridRef.current?.props.children;
            setOverviewNameColumnWidth(calculateMinColumnWidths(columns, overviewGridDivRef.current.offsetWidth, 'name', 300, true));
        }
    }, [windowSize]);

    useEffect(() => {
        // component unmount time
        return () => {
            setActiveConfiguration({});
        };
    }, []);

    useEffect(() => {
        setFormulaGridColumns([]);

        switch (view) {
            case 'scoregraph':
            case 'scoregrid':
                setViewKey('Score');
                break;
            case 'sensorgraph':
            case 'sensorgrid':
                setViewKey('Sensor');
                break;
            case 'configuration':
                setViewKey('configuration');
                break;
            case 'rawdata':
                setViewKey('RawData');
                break;
            case 'healthmonitor':
                setViewKey('healthmonitor');
                break;
            default:
        }
    }, [view]);

    useEffect(() => {
        const init = async () => {
            if (!dashboardIsCurrentTimeStamp) {
                const queryValues = queryString.parse(history.location.search);
                fetchFaultOverlay(activeNavCompany.id, queryValues.system, selectedRule.ruleId, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format());
            }
        };

        if (isEmpty(selectedRule)) {
            setFaultOverlay([]);
        }
        else {
            init();
        }
    }, [selectedRule]);

    useEffect(() => {
        const init = async () => {
            setAggregateType('None');
            if (view === 'sensorgrid' || view === 'overview') {
                setSelectedRule({});
                setSelectedRuleSensors([]);
                setSelectedSensors([]);
                setSelectedWeatherSensors([]);
            }
            setActiveConfiguration({});

            await fetchConfigurations(currentUser.id, system.id, `BOB|SystemDashboard|${viewKey}`, true);
        };

        if (system && system.id && currentUser.id && process.env.saveViewAndConfigurationEnabled && viewKey) init();
    },[system, viewKey]);

    useEffect(() => {
        const configurationData = { ...configuration };
        configurationData.workbookMode = workbookModeEnabled;
        setConfiguration(configurationData);
        initialOverviewGridDataState.take = overviewGridTake;
        setOverviewGridDataState(initialOverviewGridDataState);
        setSensorGridDataState({...sensorGridDataState, filter: initialDataStateFilter});
        setSensorGridFilterText('');
    }, [workbookModeEnabled]);

    // save or save as configuration
    useEffect(() => {
        const init =  async () => {
            const { viewName, isDefault, sharedEmails } = { ...newConfiguration };

            configuration.viewType = `System - ${viewKey}`;
            configuration.ownerId = currentUser.id;
            configuration.viewUrl = `${history.location.pathname}${history.location.search}`;

            const payload =  {
                'viewKey':      `BOB|SystemDashboard|${viewKey}`,
                'entityId':     system.id,
                'entityName':   system.name,
                'name':         viewName,
                'isDefault':    isDefault,
                'viewData':     JSON.stringify(configuration),
                'sharedEmails': sharedEmails
            };

            const updateActiveConfig = { ...payload };
            updateActiveConfig.viewData = configuration;

            const id = await saveConfiguration(currentUser.id, payload);
            setActiveConfiguration({id: id, ...updateActiveConfig});

            await fetchConfigurations(currentUser.id, system.id, `BOB|SystemDashboard|${viewKey}`);

            if (!isEmpty(redirection)) {
                handleChangetabView(redirection);
                setRedirection({});
            }
        };

        if (!isEmpty(newConfiguration)) init();
    }, [newConfiguration]);

    useEffect(() => {
        const init =  async () => {
            let payload = { ...activeConfiguration };

            if (!configuration.viewUrl) {
                const queryValues = queryString.parse(history.location.search);
                if (queryValues.viewId) {
                    delete queryValues.viewId;
                }
                const queryValuesString = queryString.stringify(queryValues);
                configuration.viewUrl = `${history.location.pathname}?${queryValuesString}`;
            }

            payload.entityName = payload.entityName || '';
            payload.viewData = JSON.stringify(configuration);

            await updateConfiguration(activeConfiguration.id, payload);
            await fetchConfigurations(currentUser.id, system.id, `BOB|SystemDashboard|${viewKey}`);

            // update active configuration
            let updatedPayload = { ...payload };

            updatedPayload.viewData = configuration;
            setActiveConfiguration(updatedPayload);
        };

        if (!isEmpty(activeConfiguration) && updateConfigurationData) init();
    }, [updateConfigurationData]);

    useEffect(() => {
        const init = async () => {
            const viewData = activeConfiguration.viewData;
            viewData.workbookMode = viewData.workbookMode || false;

            if ( !isEmpty(viewData.sensorGraphConfiguration)) {
                setSensorConfiguration(viewData.sensorGraphConfiguration);
                setAxes(viewData.sensorGraphConfiguration.axes);
            }

            setSelectedWeatherSensors(viewData.selectedWeatherSensors ? viewData.selectedWeatherSensors : []);
            setConfiguration(viewData);

            const tempSensorGridDataState = sensorGridDataState;
            tempSensorGridDataState.filter = viewData.filter || initialDataStateFilter;
            setSensorGridDataState(tempSensorGridDataState);
            setFormatObj(viewData.conditionalFormat || {});
            setColumnNames(viewData.columns || []);
            setWorkBookMode(viewData.workbookMode || false);
            setFormulaColumns(viewData.selectedFormulaColumns || []);
            setFormulaGridColumns(viewData.selectedFormulaColumns || []);
            setAggregateType(viewData.aggregateType || 'None');

            if (!isEmpty(viewData.selectedRule)) {
                setSelectedRule(viewData.selectedRule);
                if (!dashboardIsCurrentTimeStamp) {
                    await fetchFaultOverlay(activeNavCompany.id, queryValues.system, viewData.selectedRule.ruleId, dashboardStartTimeStamp.format(), dashboardEndTimeStamp.format());
                }
            }
            else {
                setSelectedRule({});
            }

            if (!isEmpty(viewData.selectedSensors)) {
                const combinedSensors = _.unionBy(viewData.selectedRule?.sensorIds, viewData.selectedSensors, 'id');
                setSelectedRuleSensors(combinedSensors);
            }
        };

        if (!isEmpty(activeConfiguration) && system && activeConfiguration.entityId === system.id) init();
    }, [activeConfiguration]);

    useEffect(() => {
        const configurationData = { ...configuration };
        configurationData.aggregateType = aggregateType;
        setConfiguration(configurationData);
    }, [aggregateType]);

    // this is for clearing applied configuration
    useEffect(() => {
        const clear =  () => {
            setConfiguration({});
            setSensorGridDataState(initialSensorGridDataState);
            setFormatObj({});
            setColumnNames([]);
            setIsClearAppliedConfiguration(false);
            setFormulaGridColumns([]);
        };

        if (isClearAppliedConfiguration) clear();
    }, [isClearAppliedConfiguration]);

    useEffect(() => {
        if (formulaValues) {
            addFormulaColumn(formulaValues);
        }
    }, [formulaValues]);

    const addFormulaColumn = formula => {
        const currentFormulaList = _.cloneDeep(formulaColumns);
        const foundColumn = currentFormulaList.find(c => c.fieldName === formula.fieldName);
        if (!foundColumn) {
            const newFormulaList = [...currentFormulaList, formulaValues];
            setFormulaColumns(newFormulaList);
            const newColumn = {
                name:       formulaValues.cellTitle,
                title:      formulaValues.cellTitle,
                field:      formulaValues.fieldName,
                filter:     'numeric',
                format:     '{0:n}',
                isFormula:  true,
                orderIndex: formulaValues.cellIndex
            };

            let columnList = [...columnNames, newColumn];
            let exportColumnList = [...exportColumnNames, newColumn];
            setColumnNames(columnList);
            setExportColumnNames(exportColumnList);
            configuration.columns = columnList;
            configuration.selectedFormulaColumns = newFormulaList;
            setConfiguration(configuration);
        }
        else {
            const index = currentFormulaList.findIndex(c => c.fieldName === formula.fieldName);
            currentFormulaList[index] = formula;

            // grid columns
            try {
                columnNames.find(c => c.field === formula.fieldName).name = formula.cellTitle;
                columnNames.find(c => c.field === formula.fieldName).title = formula.cellTitle;
            }
            catch {
                // no need to do anything
            }

            // export columns
            try {
                exportColumnNames.find(c => c.field === formula.fieldName).name = formula.cellTitle;
                exportColumnNames.find(c => c.field === formula.fieldName).title = formula.cellTitle;
            }
            catch {
                // no need to do antying
            }

            setFormulaColumns(currentFormulaList);
            configuration.columns = columnNames;
            configuration.selectedFormulaColumns = currentFormulaList;
            setConfiguration(configuration);
        }

        const dataSet = addFormulaToGridDataSet(formulaValues, formulaValues.fieldName, sensorGridData);
        setSensorGridData(dataSet);
    };

    const addFormulaToGridDataSet = (formula, fieldName, gridData) => {
        const newDataSet = _.cloneDeep(gridData);
        let formulaResult = 0;
        newDataSet.map(data => {
            switch (formula.operator.operator) {
                case '+':
                    formulaResult = Number(data[formula.columnOne.field]) + Number(data[formula.columnTwo.field]);
                    break;
                case '-':
                    formulaResult = Number(data[formula.columnOne.field]) - Number(data[formula.columnTwo.field]);
                    break;
                case '*':
                    formulaResult = Number(data[formula.columnOne.field]) * Number(data[formula.columnTwo.field]);
                    break;
                case '/':
                    formulaResult = Number(data[formula.columnOne.field]) / Number(data[formula.columnTwo.field]);
                    break;
                default:
                    formulaResult = Number(data[formula.columnOne.field]) + Number(data[formula.columnTwo.field]);
                    break;
            }
            return data[formula.fieldName] = Number(formulaResult.toFixed(formula.precision));
        });
        return newDataSet;
    };

    const updateSystemSensorGraphHeight = () => {
        switch (window.devicePixelRatio) {
            case 1:
                setSensorGraphHeight('60vh');
                break;
            case 1.25:
                setSensorGraphHeight('50vh');
                break;
            default:
                setSensorGraphHeight('60vh');
        }
    };
    const getGanttSeries = (c, i) => {
        return {
            sensorId:   c.sensorId,
            sensorName: c.sensorName,
            axis:       'yAxis',
            dataColor:  i % 2 === 0 ? '#ff6d01' : '#6f6f6f',
            data:       []
        };
    };

    const setChartTypeProps = (chart) =>{
        setChartType(chart);
    };

    const setScoreChartTypeProps = (chart) =>{
        setScoreChartType(chart);
    };


    const getUnitDisplayValue = (rawUnitId) => {
        let targetUnit;
        if (rawUnits) {
            rawUnits.forEach(unit => {
                unit.items.forEach(item => {
                    if (item.id === rawUnitId) {
                        targetUnit = { ...item };
                    }
                });
            });
        }
        return targetUnit ? targetUnit.displayValue : '-';
    };

    const processEntitySensorData = () => {
        let numericDataSet = [];
        let ganttDs = [];
        let lineStyles = ['solid', 'dash', 'longDash', 'dashDot', 'longDashDot', 'longDashDotDot'];
        let lineIndex = 0;
        let lineStyleMap = {};
        let ganttAxisMin = 0;
        let ganttAxisMax = 0;
        let booleanDataSet = [];
        let initialOverlayData = [];

        if (entitySensorData) {
            entitySensorData.forEach((sensor, index) => {
                if (index === 0) {
                    sensor.data.forEach(point => {
                        initialOverlayData.push({
                            timestamp: point.timestamp,
                            value:     null
                        });
                    });
                }

                if (sensor && sensor.data && sensor.data.length > 0) {
                    if (sensor.isWeather) {
                        switch (sensor.sensorName) {
                            case 'Humidity':
                                sensor.unitDisplayValue = '%';
                                break;
                            case 'Pressure':
                                sensor.unitDisplayValue = ' hPa';
                                break;
                            default:
                                sensor.unitDisplayValue = '°F';
                                break;
                        }
                    } else {
                        sensor.unitDisplayValue = getUnitDisplayValue(sensor.presentationUnitId);
                    }

                    if (sensor.data.find(item => item.dataType && item.dataType.toLowerCase() === 'boolean')) {
                        booleanDataSet.push(sensor);
                    }
                    else if (sensor.data.find(item => !isNaN(item.convertedValue))) {
                        let filteredSensorData = sensor.data.filter(item => !isNaN(item.convertedValue));
                        filteredSensorData = filteredSensorData.map(item => ({ ...item, 'unitDisplayValue': sensor.unitDisplayValue }));

                        let sortedSensorData = sortBy(filteredSensorData, 'convertedValue');
                        sortedSensorData = sortedSensorData.filter(item => item.convertedValue !== null);

                        sensor.min = !isEmpty(sortedSensorData) ? Math.floor(sortedSensorData[0].convertedValue) - 10 : 0;
                        sensor.max = !isEmpty(sortedSensorData) ? Math.floor(sortedSensorData[sortedSensorData.length - 1].convertedValue) + 10 : 1;

                        if (!lineStyleMap[sensor.axis]) {
                            sensor.lineType = lineStyles[lineIndex];
                            lineStyleMap[sensor.axis] = lineStyles[lineIndex];
                            lineIndex = lineIndex < lineStyles.length - 1 ? lineIndex + 1 : 0;
                        }
                        else sensor.lineType = lineStyleMap[sensor.axis];
                        sensor.visible = true;
                        sensor['data'] = filteredSensorData;
                        numericDataSet.push(sensor);
                    }
                }
            });
            if (faultOverlay) {
                faultOverlay.forEach(item => {
                    if (item.status === 'InFault') {
                        initialOverlayData.forEach(point => {
                            if (moment(point.timestamp).local().isBetween(moment(item.startTime).seconds(0).milliseconds(0).local(), moment(item.endTime).seconds(0).milliseconds(0).local(), 'minute', '[]')) {
                                point.value = 1;
                            }
                        });
                    }
                });

                setOverlayData(initialOverlayData);
            }
            ganttAxisMax = booleanDataSet.length + 1;
            //Creating the gaps for plotting Gantt chart in bottom pane for boolean dataset
            booleanDataSet.forEach((bdata, i) => {
                bdata.data = bdata.data.sort(function (a, b) {
                    return a.timestamp - b.timestamp;
                });

                let ganttSeries = getGanttSeries(bdata, i);
                let lastval = bdata.data[0].timestamp.getTime();
                bdata.data.forEach((data, j) => {
                    if (lastval !== data.timestamp.getTime()) {
                        if (ganttSeries.data.length >0 && ganttSeries.data[ganttSeries.data.length - 1].booleanValue !== data.convertedValue) {
                            ganttDs.push(ganttSeries);
                            let lastpoint = {...ganttSeries.data[ganttSeries.data.length - 1]};
                            lastpoint.booleanValue = data.convertedValue;
                            ganttSeries = getGanttSeries(bdata, i);
                            ganttSeries.sensorId = bdata.sensorId;
                            ganttSeries.sensorName = bdata.sensorName;
                            ganttSeries.data.push(lastpoint);
                        }
                        data.booleanValue = data.convertedValue === 'Poll Failure' ? null : data.convertedValue;

                        if (data.convertedValue === null || data.convertedValue === 'Poll Failure') {
                            ganttSeries.dataColor = 'url(#pattern2)';
                        }
                        else if (data.convertedValue.toString().toLowerCase() === 'false') {
                            ganttSeries.dataColor = '#FFFFFF';
                        }
                        data.convertedValue = i + 1;
                        ganttSeries.data.push(data);
                        lastval = lastval + (data.sampleInterval * 60 * 1000);
                    }
                    else {
                        ganttDs.push(ganttSeries);
                        ganttSeries = getGanttSeries(bdata, i);
                        ganttSeries.sensorId = bdata.sensorId;
                        ganttSeries.sensorName = bdata.sensorName;
                        data.booleanValue = data.convertedValue === 'Poll Failure' ? null : data.convertedValue;

                        if (data.convertedValue === null || data.convertedValue === 'Poll Failure') {
                            ganttSeries.dataColor = 'url(#pattern2)';
                        }
                        else if (data.convertedValue.toString().toLowerCase() === 'false') {
                            ganttSeries.dataColor = '#FFFFFF';
                        }
                        data.convertedValue = i + 1;
                        ganttSeries.data.push(data);
                    }
                });
                if (ganttSeries.data.length > 0) {
                    if (ganttSeries.data.length === 1 && !ganttSeries.data[0].booleanValue) {
                        ganttSeries.data = [];
                    }
                    ganttDs.push(ganttSeries);
                }
            });
        }

        setNumericDataSet(numericDataSet);
        renderValueAxis(numericDataSet);
        setBooleanDataSet(booleanDataSet);
        setGanttDs(ganttDs);
        setGanttAxisMin(ganttAxisMin);
        setGanttAxisMax(ganttAxisMax);

        window.scrollTo(0, document.body.scrollHeight);
    };

    const onLegendItemClick = (e) => {
        let index = e.seriesIndex;
        if (numericDataSet.length > index) {
            let ds = numericDataSet;
            ds[index].visible = !ds[index].visible;
            setNumericDataSet(ds);
            renderValueAxis(ds);
        }
    };

    useEffect(() => {
        const queryValues = queryString.parse(history.location.search);

        let viewChildId = queryValues.viewChildId;

        let activeView = getActiveViewName(viewChildId);

        setView(activeView);
    }, [history.location.search]);

    useEffect(() => {
        return () => {
            zoomLevel100.removeEventListener('change', updateSystemSensorGraphHeight);
            zoomLevel125.removeEventListener('change', updateSystemSensorGraphHeight);
        };
    }, []);

    useEffect(() => {
        const queryValues = queryString.parse(history.location.search);

        if (queryValues.view) {
            setView(queryValues.view);
        }

        zoomLevel100.addEventListener('change', updateSystemSensorGraphHeight);
        zoomLevel125.addEventListener('change', updateSystemSensorGraphHeight);
        updateSystemSensorGraphHeight();
        setNumericDataSet([]);
        setBooleanDataSet([]);
    }, []);

    useEffect(() => {
        setTableSensors(sensors);
    }, [sensors]);

    const sharedTooltipRender = (context) => (<SharedTooltip {...context} />);

    const labelContent = (e) => {
        if (e.value !== 0 && e.value - 1 < booleanDataSet.length) {
            return booleanDataSet[e.value - 1].sensorName;
        }
        return '';
    };

    useEffect(() => {
        let columns = [{ name: 'Timestamp', title: 'Timestamp', field: 'timestamp', filter: 'date', locked: true }];
        let processedData = [];
        if (!isEmpty(entitySensorData)) {

            // apply saved column order from configuration
            let orderedEntitySensorData = [];
            if (!isEmpty(activeConfiguration) && activeConfiguration.viewKey.includes('Sensor')) {
                if (configuration.selectedSensors && _.isEqual(activeConfiguration.viewData.selectedSensors, configuration.selectedSensors)) {
                    let savedColumns = cloneDeep(activeConfiguration.viewData.columns.filter(c => c.isFormula !== true));
                    if (!isEmpty(savedColumns) && savedColumns.length > 1) {
                        if (!isEmpty(selectedWeatherSensors)) {
                            selectedWeatherSensors.forEach(sensor => {
                                switch (sensor) {
                                    case 'temperature':
                                        if (!savedColumns.find(item => item.name === 'Temperature')) {
                                            savedColumns.push({ field: activeNavSite.address.postalCode + ':temp' });
                                        }
                                        break;
                                    case 'minTemperature':
                                        if (!savedColumns.find(item => item.name === 'Min Temperature')) {
                                            savedColumns.push({ field: activeNavSite.address.postalCode + ':tempmin' });
                                        }
                                        break;
                                    case 'maxTemperature':
                                        if (!savedColumns.find(item => item.name === 'Max Temperature')) {
                                            savedColumns.push({ field: activeNavSite.address.postalCode + ':tempmax' });
                                        }
                                        break;
                                    case 'humidity':
                                        if (!savedColumns.find(item => item.name === 'Humidity')) {
                                            savedColumns.push({ field: activeNavSite.address.postalCode + ':humidity' });
                                        }
                                        break;
                                    case 'pressure':
                                        if (!savedColumns.find(item => item.name === 'Pressure')) {
                                            savedColumns.push({ field: activeNavSite.address.postalCode + ':pressure' });
                                        }
                                        break;
                                    default:
                                        savedColumns.push({ field: activeNavSite.address.postalCode + ':' + sensor });
                                        break;
                                }
                            });
                        }

                        savedColumns.forEach(item => {
                            let col = entitySensorData.filter(sensor => sensor.sensorId === item.field);
                            orderedEntitySensorData.push(col[0]);
                        });
                        entitySensorData = orderedEntitySensorData.filter(item => item !== undefined);
                    }
                }
            }

            entitySensorData.forEach(item => {
                // extracting column names for sensorgrid
                // set the type of filter for the column
                let filterType = 'numeric';
                if (isEmpty(item.data)) {
                    filterType = 'text';
                }
                else if (item.data.length > 0) {
                    const booleanType = item.data.find(item => item.dataType && item.dataType.toLowerCase() === 'boolean');
                    if (booleanType) filterType = 'boolean';
                }

                columns.push({
                    name:   item.sensorName,
                    title:  item.sensorName,
                    field:  item.sensorId,
                    filter: filterType,
                    format: filterType === 'numeric' ? '{0:n}' : null
                });
                // extracting column data for sensorgrid
                // for filtering purposes the data must be in the same format as the filter
                item.data.forEach(data => {
                    let dataPoint = {
                        sensorName: item.sensorName,
                        timestamp:  data.timestamp
                    };
                    dataPoint[item.sensorId] = data.convertedValue;
                    processedData.push(dataPoint);
                });
            });

            if (formulaColumns) {
                formulaColumns.forEach(item => {
                    const foundColumn = columns.find(c => c.field === item.fieldName);
                    if (!foundColumn) {
                        columns.push({
                            name:       item.cellTitle,
                            title:      item.cellTitle,
                            field:      item.fieldName,
                            filter:     'numeric',
                            format:     '{0:n}',
                            isFormula:  true,
                            orderIndex: item.cellIndex
                        });
                    }
                });
            }

            // save selected columns in configuration
            if (viewKey === 'Sensor') {
                configuration.columns = columns;
                if (!_.isEmpty(formulaColumns)) {
                    configuration.selectedFormulaColumns = formulaColumns;
                }
                setConfiguration(configuration);
            }
        }

        const result = _(processedData)
            .groupBy('timestamp')
            .map(_.spread(_.assign))
            .value();

        const resultClone = _.cloneDeep(result);
        // Add the formulas to the sensorgriddata
        if (!isEmpty(formulaColumns)) {
            resultClone.forEach(data => {
                let formulaResult = 0;
                formulaColumns.forEach(formula => {
                    formulaResult = 0;
                    switch (formula.operator.operator) {
                        case '+':
                            formulaResult = Number(data[formula.columnOne.field]) + Number(data[formula.columnTwo.field]);
                            break;
                        case '-':
                            formulaResult = Number(data[formula.columnOne.field]) - Number(data[formula.columnTwo.field]);
                            break;
                        case '*':
                            formulaResult = Number(data[formula.columnOne.field]) * Number(data[formula.columnTwo.field]);
                            break;
                        case '/':
                            formulaResult = Number(data[formula.columnOne.field]) / Number(data[formula.columnTwo.field]);
                            break;
                        default:
                            formulaResult = Number(data[formula.columnOne.field]) + Number(data[formula.columnTwo.field]);
                            break;
                    }
                    return data[formula.fieldName] = Number(formulaResult.toFixed(formula.precision));
                });

            });
        }

        setSensorGridData(resultClone);
        setColumnNames(columns);
        setExportColumnNames(columns);

        processEntitySensorData();

    }, [entitySensorData]);

    useEffect(() => {
        const columns = columnNames.map(column => {
            const filterType = column.filter === 'text' ? TextFilter : column.filter === 'numeric' ? NumericFilter : column.filter === 'date' ? DateFilter : BooleanFilter;
            const operatorList = column.filter === 'text' ? Operators.text : column.filter === 'numeric' ? Operators.numeric : column.filter === 'date' ? Operators.date : Operators.boolean;
            return {
                name:      column.field,
                label:     column.name ? column.name : column.title,
                filter:    filterType,
                operators: operatorList
            };
        });
        setSensorGridFields(columns);
    }, [columnNames]);

    const handleClose = () => {
        setShowModal(false);
    };

    //Ref - https://www.geeksforgeeks.org/interval-tree/
    class Interval {
        constructor() {
            this.low = 0;
            this.high = 0;
        }
    }

    class ITNode {
        // 'i' could also be a normal variable
        constructor() {
            this.max = 0;
            this.left = null;
            this.right = null;
            this.i = null;
        }
    }

    // A utility function to create a new node
    function newNodeDouble(l, h) {
        var temp = new Interval();
        temp.low = l;
        temp.high = h;
        return temp;
    }

    // A utility function to create a new node
    function newNodeSingle(i) {
        var temp = new ITNode();
        temp.i = i;
        temp.max = i.high;
        temp.left = temp.right = null;
        return temp;
    }

    // A utility function to insert a new
    // Interval Search Tree Node. This is
    // similar to BST Insert. Here the
    // low value of interval is used to
    // maintain BST property
    function insert(root, i) {

        // Base case: Tree is empty,
        // new node becomes root
        if (root == null)
            return newNodeSingle(i);

        // Get low value of interval at root
        var l = root.i.low;

        // If root's low value is smaller,
        // then new interval goes to left subtree
        if (i.low < l)
            root.left = insert(root.left, i);

        // Else, new node goes to right subtree.
        else
            root.right = insert(root.right, i);

        // Update the max value of this
        // ancestor if needed
        if (root.max < i.high)
            root.max = i.high;
        return root;
    }

    // A utility function to check if given
    // two intervals overlap
    function doOVerlap(i1, i2) {
        if (i1.low < i2.high && i2.low < i1.high)
            return true;
        return false;
    }

    // The main function that searches a given
    // interval i in a given Interval Tree.
    function overlapSearch(root, i) {

        // Base Case, tree is empty
        if (root == null)
            return null;

        // If given interval overlaps with root
        if (doOVerlap(root.i, i))
            return root.i;

        // If left child of root is present
        // and max of left child is greater
        // than or equal to given interval,
        // then i may overlap with an interval
        // is left subtree
        if (root.left != null &&
            root.left.max >= i.low)
            return overlapSearch(root.left, i);

        // Else interval can only
        // overlap with right subtree
        return overlapSearch(root.right, i);
    }

    // This function prints all conflicting
    // appointments in a given array of apointments.
    function printConflicting(appt, n) {

        // Create an empty Interval Search
        // Tree, add first appointment
        var root = null;
        root = insert(root, appt[0]);

        // Process rest of the intervals
        for (var i = 1; i < n; i++) {

            // If current appointment conflicts
            // with any of the existing intervals,
            // print it
            var res = overlapSearch(root, appt[i]);

            if (res != null) {
                appt[i].conflicted = true;
                res.conflicted = true;
            }
            // Insert this appointment
            root = insert(root, appt[i]);
        }
    }

    const validateConditions = () => {
        const intervals = [];
        formatList.forEach(c => {
            if (c.operator === 'Greater Than') {
                intervals.push(newNodeDouble(c.field1, Number.MAX_SAFE_INTEGER));
            }
            else if (c.operator === 'Less Than') {
                intervals.push(newNodeDouble(0, c.field1));
            }
            else if (c.operator === 'Between') {
                intervals.push(newNodeDouble(c.field1, c.field2));
            }
            else if (c.operator === 'Equals') {
                intervals.push(newNodeDouble(c.field1, c.field1));
            }
        });
        printConflicting(intervals, intervals.length);
        return intervals;
    };

    const handleSubmit = (data,key) =>{
        if (formatType === 'numeric') {
            let gaps = validateConditions();
            let formatlist = formatList;
            let conflict = false;
            gaps.forEach((c,i)=>{
                formatlist[i].conflicted = c.conflicted?true:false;
                if (c.conflicted)
                    conflict = true;
            });
            if (conflict) {
                setFormatList([...formatlist]);
                return false;
            }
        }
        let obj = formatObj;
        obj[formatKey] = JSON.parse(JSON.stringify(formatList));
        setConfiguration({ ...configuration, conditionalFormat: obj });
        setFormatObj(obj);
        setColumnNames([...columnNames]);
        return true;
    };

    const updateFormat = (data, i, key) => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        if (formatlist[i]) {
            formatlist[i][key] = data;
        }
        else {
            let obj = {};
            obj[key] = data;
            formatlist.push(obj);
        }
        setFormatList([...formatlist]);
    };

    const addItem = () => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        formatlist.push({ 'operator': '', 'condition': '' });
        setFormatList([...formatlist]);
    };

    const removeItem = (index) => {
        let formatlist = formatList && formatList.length > 0 ? formatList : [];
        formatlist.splice(index, 1);
        setFormatList([...formatlist]);
    };
    const SharedTooltip = (props) => {
        const zone = moment.tz.guess();
        const pointDate = props.points[0].category;
        let points = props.points.filter(c => c.series.axis !== 'bottom');

        if (!isEmpty(selectedRule) && !props.points.find(c => c.series.axis === 'Fault')) {
            points.unshift({
                dataItem: {
                    unitDisplayValue: '-',
                    value:            null,
                    convertedValue:   'Ok'
                },
                series: {
                    name: selectedRule.ruleName,
                    axis: 'Fault'
                }
            });
        }

        points = points.map(c => {
            if (c.series.axis === 'Fault') {
                c.dataItem.unitDisplayValue = '-';
                if (c.dataItem.value === 1) {
                    c.dataItem.convertedValue = 'InFault';
                }
                c.series.name = selectedRule.ruleName;
                c.series.axis = 'Fault';
                return c;
            }
            return c;
        });

        let booleans = props.points.filter(c=>c.series.axis === 'bottom');
        let sensors =[];
        if (ganttDs && ganttDs.length > 0) {
            for (var i = 0; i < ganttDs.length; i++) {
                let found = false;
                for (var j = 0; j < booleans.length; j++) {
                    if (ganttDs[i].sensorName === booleans[j].series.name) {
                        found = true;
                        if (sensors.indexOf(ganttDs[i].sensorName) === -1) {
                            sensors.push(ganttDs[i].sensorName);
                            points.push({ dataItem: { booleanValue: booleans[j].series.color === 'url(#pattern2)' ? null: booleans[j].series.color ===  '#FFFFFF' ? false:true }, series: { color: (booleans[j].series.color === '#FFFFFF' || booleans[j].series.color === 'url(#pattern2)') ? '#23c8fa':booleans[j].series.color, axis: 'Boolean', name: ganttDs[i].sensorName } });
                        }
                        break;
                    }
                }
                if (!found && (sensors.indexOf(ganttDs[i].sensorName) === -1)) {
                    sensors.push(ganttDs[i].sensorName);
                    points.push({ dataItem: { booleanValue: false }, series: { color: ganttDs[i].dataColor, axis: 'Boolean', name: ganttDs[i].sensorName } });
                }
            }
        }

        //group by axis
        let group = points.reduce((r, a) => {
            if (!a.series.axis) {
                a.series.axis = 'Axis';
            }
            r[a.series.axis] = [...r[a.series.axis] || [], a];
            return r;
        }, {});

        let finalArray = [];
        let booleanobj = null;
        for (var pt in group) {
            if (Object.prototype.hasOwnProperty.call(group, pt) && pt !== 'Boolean') {
                finalArray.push({ axis: pt, points: group[pt].sort((a, b) => { return a.series.name.localeCompare(b.series.name); }) });
            }
            else if (pt === 'Boolean') {
                booleanobj = { axis: pt, points: group[pt].sort((a, b) => { return a.series.name.localeCompare(b.series.name); }) };
            }
        }
        if (booleanobj) {
            finalArray.push(booleanobj);
        }

        const booleanAdjustment = booleanobj ? 30 : 0;
        let marginTop = -40;
        switch (points.length) {
            case 1:
                marginTop = 300 - booleanAdjustment;
                break;
            case 2:
                marginTop = 275 - booleanAdjustment;
                break;
            case 3:
                marginTop = 260 - booleanAdjustment;
                break;
            case 4:
                marginTop = 245 - booleanAdjustment;
                break;
            case 5:
                marginTop = 230 - booleanAdjustment;
                break;
            case 6:
                marginTop = 215 - booleanAdjustment;
                break;
            case 7:
                marginTop = 190 - booleanAdjustment;
                break;
            case 8:
                marginTop = 175 - booleanAdjustment;
                break;
            case 9:
                marginTop = 150 - booleanAdjustment;
                break;
            case 10:
                marginTop = 130 - booleanAdjustment;
                break;
            case 11:
                marginTop = 110 - booleanAdjustment;
                break;
            default:
                marginTop = 300 - booleanAdjustment;
        }
        let root = document.documentElement;
        root.style.setProperty('--sharedTooltipTop', marginTop + 'px');

        return (
            <div>
                <style>
                    {
                        `
                            .k-chart-shared-tooltip {
                                position: fixed;
                                top: var(--sharedTooltipTop);
                                margin-left: -50px;
                                min-width: auto;
                                padding-bottom: 10px;
                            }
                        `
                    }
                </style>
                <React.Fragment>
                    <div style={{color: '#000000', fontWeight: 'bold', height: 20, marginBottom: 8}}>
                        {points && points.length > 0 ? moment(pointDate).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(pointDate), zone) : ''}
                    </div>
                    {
                        finalArray.map((c, index) => (
                            <React.Fragment key={index}>
                                <React.Fragment>
                                    {c.points.map((point) => (
                                        <div key={Math.random()} style={{overflowWrap: 'break-word', height: 20, color: point.series && point.series.color ? point.series.color : '#000000'}}>
                                            {point.series.axis === 'Boolean' ?
                                                <React.Fragment>{point.series.name ?
                                                    <React.Fragment>{
                                                        `${ point.series.name } - ${ point.dataItem.booleanValue === true ?
                                                            'True'
                                                            : point.dataItem.booleanValue === null ?
                                                                'No Data'
                                                                : 'False' }`
                                                    }
                                                    </React.Fragment>
                                                    : null
                                                }
                                                </React.Fragment>
                                                : <React.Fragment>
                                                    <React.Fragment>{point.series.name ? <React.Fragment>{`${ point.series.name } - `}</React.Fragment>
                                                        : null
                                                    }
                                                    </React.Fragment>
                                                    <React.Fragment>{
                                                        `${ point.dataItem.convertedValue ?
                                                            point.dataItem.convertedValue === 'InFault' || point.dataItem.convertedValue === 'Ok' ?
                                                                point.dataItem.convertedValue
                                                                : parseFloat(point.dataItem.convertedValue).toFixed(2) : 0 }${ point.dataItem.unitDisplayValue !== '-' ?
                                                            point.dataItem.unitDisplayValue
                                                            : '' }`
                                                    }
                                                    </React.Fragment>
                                                </React.Fragment>
                                            }
                                        </div>
                                    ))
                                    }
                                </React.Fragment>
                            </React.Fragment>
                        ))}
                </React.Fragment>
            </div>
        );
    };

    const handleChangeView = view => {
        setView(view);
    };

    const handleExport = event => {
        setExportModalOpen(true);
    };

    const handleExportGrid = event => {
        if (view === 'sensorgrid') {
            const options = _export.current.workbookOptions();
            const rows = options.sheets[0].rows;
            rows.forEach((row, rindex) => {
                if (row.type === 'data') {
                    row.cells.forEach((cell, colindex) => {
                        if (colindex === 0) {
                            formatTimeStampCell(cell);
                        }
                        else formatDataCell(cell, colindex);
                    });
                }
            });
            _export.current.save(options);
        }
        else if (view === 'scoregrid') {
            doRefresh(prev => prev + 1);
        }
    };

    const formatTimeStampCell = (cell) => {
        const conditions = formatObj['timestamp'];
        let _className = '';
        const datatype = 'date';
        let zone = moment.tz.guess();
        let fd = moment(cell.value).format('YYYY-MM-DD h:mm A');
        const timeDisplay = fd + ' ' + getTimeZoneAbbr(cell.value, zone);
        if (conditions && cell.value !== null && cell.value !== '' && cell.value !== undefined) {
            _className = parseCondition(conditions, fd, datatype);
        }
        if (_className) {
            cell.background = styleMap[_className].background;
            cell.color = styleMap[_className].color;
        }
        cell.value = timeDisplay;
    };

    const formatDataCell = (cell,colindex) => {
        const field = exportColumnNames[colindex].field;
        const conditions = formatObj[field];
        let _className = '';
        const datatype = exportColumnNames[colindex].filter;
        if (conditions && cell.value !== null && cell.value !== '' && cell.value !== undefined) {
            _className = parseCondition(conditions, cell.value, datatype);
        }
        if (_className) {
            cell.background = styleMap[_className].background;
            cell.color = styleMap[_className].color;
        }
        if (datatype === 'numeric') {
            cell.format = '#,###,##0.##########';
        }
    };

    const handleCreateSensor = () => {
        history.push({ pathname: '/v2/dashboard/system/sensor', search: history.location.search, state: { entityId: queryValues.system, sensorHistory: [...selectedSensors], ruleHistory: selectedRule, entityType: 'system' } });
    };

    const handleCalculatedSensor = () => {
        history.push({ pathname: '/v2/dashboard/calculated/sensor', search: history.location.search, state: { entityId: activeNavEquipment.id, sensorHistory: [...selectedSensors], ruleHistory: selectedRule, entityType: 'system' } });
    };

    const handleImageDownload = () => {
        if (view === 'sensorgraph') {
            downloadChart(chart, 'Sensor Graph.png');
        }
        else if (view === 'scoregraph') {
            let scorepanel = propFunc.getChartInstance();
            if (scorepanel) {
                downloadChart(scorepanel, 'Score Graph.png');
            }
        }
    };

    const downloadChart = (chart, name) => {
        if (chart) {
            let chartRefValue = chart.current;
            if (chartRefValue && chartRefValue.element) {
                const imageRect = new Rect(new Point(chartRefValue.element.offsetWidth - 110, chartRefValue.element.offsetHeight), new Size(110, 30));
                const imageUrl = `/assets/images/k2acopyright.png`;
                const image = new Image(imageUrl, imageRect);
                chartRefValue.surface.draw(image);
                const text = new Text(
                    system.name+' - '+ activeNavSite.name,
                    new Point((chartRefValue.element.offsetWidth/2) -100, 15),
                    { font: '12pt sans-serif',id: 'chart-header-label' }
                );
                chartRefValue.surface.draw(text);
                const chartVisual = exportVisual(chartRefValue);
                if (chartVisual) {
                    exportImage(chartVisual).then(dataURI => saveAs(dataURI, name));
                }
            }
        }
    };

    const isValid = () => {
        switch (view) {
            case 'sensorgrid':
            case 'sensorgraph':
                return isEmpty(entitySensorData);
            case 'scoregrid':
            case 'scoregraph':
                return isEmpty(entityScoringData);
            case 'overview':
                return true;
            default:
                return true;
        }
    };

    const handleConfigure = () => {
        handleChangetabView({ viewParentId: '383849dd-bd20-4ee2-a0e5-1b192ddc4f81', key: '4b25aeb8-02d4-4522-9f77-870ab40abb74', text: 'Configuration', cssClass: 'ViewSelector_menuItem__3b_t9' });
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
        if (workbookModeEnabled) {
            const dataState = sensorGridDataState;
            dataState.filter = [];
            setSensorGridDataState(dataState);
            const scoreDataState = scoreGridDataState;
            scoreDataState.filter = initialDataStateFilter;
            setScoreGridDataState(scoreDataState);
            const ruleDataState = ruleGridDataState;
            ruleDataState.filter = initialDataStateFilter;
            setRuleGridDataState(ruleDataState);
            const ruleGraphDataState = ruleGraphGridDataState;
            ruleGraphDataState.filter = initialDataStateFilter;
            setRuleGraphGridDataState(ruleGraphDataState);
        }
    };

    if (!isActive) return null;

    const renderActionItem = () => {
        return (
            <React.Fragment>
                {
                    view === 'sensorgrid' || view === 'scoregrid' ?
                        <div className={classes.AggregateContainer}>
                            <div className={classes.AggregateDivContainer}>
                                <div className={classes.AggregateDivLabel}>Aggregate Type: </div>
                                <div>
                                    <GridAggregateSelector
                                        aggregateType={aggregateType}
                                        setAggregateType={setAggregateType}
                                    />
                                </div>
                            </div>
                        </div>
                        : null
                }
                {view === 'sensorgrid' || view === 'scoregraph' || view === 'scoregrid' || view === 'overview' ?
                    <div className={view === 'scoregraph' ? classes.ScoreFilterContainer : classes.SensorFilterContainer}>
                        <BobWorkbookModeButton
                            handleWorkbookMode={handleWorkbookMode}
                            workbookMode={workbookModeEnabled}
                        />
                    </div>
                    : null
                }
                { view !== 'overview' ?
                    <div className={classes.SensorSelectContainer}>
                        <ScoreSensorSelect
                            axes={axes}
                            meta={allSensorsMeta}
                            parentId={queryValues.system}
                            search={fetchEntitySensors}
                            sensors={allSensors}
                            siteId={queryValues.site}
                            handleChangeView={handleChangeView}
                            handleChangeTabView={handleConfigure}
                            activeConfiguration={activeConfiguration}
                            configuration={configuration}
                            setConfiguration={setConfiguration}
                            view={view}
                        />
                    </div>
                    : null
                }
                <div className={classes.TotalsContainer}>
                    <RuleTotalsPanel />
                </div>
                {
                    view === 'configuration' ?
                        null :
                        <div
                            className={classes.RefreshContainer}
                            aria-hidden="true"
                            role="button"
                            tabIndex={0}
                            onClick={refreshGrid}
                        >
                            <span className="material-icons-outlined">refresh</span>
                        </div>
                }
                <div className={classes.MenuContainer}>
                    <BobActionMenu
                        activeTab={'SystemSensors'}
                        isExport={view === 'overview' ? false : true}
                        isDisableExport={isValid()}
                        view={view}
                        handleExport={handleExport}
                        handleExportGrid={handleExportGrid}
                        handleImageDownload={() => handleImageDownload()}
                        handleCreateSensor={() => handleCreateSensor()}
                        handleCalculatedSensor={() => handleCalculatedSensor()}
                        handleCreateSubscription={(value) => handleToggleSubscribeToEquipmentAlertsModal(value)}
                    />
                </div>
            </React.Fragment>
        );
    };

    const sourceNameCell = props => {
        const { calculatedSensor, linkedSource, linkedSourceText } = props.dataItem;
        let iconType = 'link';

        if (calculatedSensor) {
            iconType = 'calculate';
        } else if (isNil(linkedSource.agentName)) {
            iconType = 'link_off';
        }

        return (
            <td>
                <HtmlTooltip
                    information={linkedSourceText}
                    placement="top-start"
                    body={
                        <div>
                            <span className={'material-icons-outlined md-18'} style={{paddingRight: '5px', verticalAlign: 'middle'}}>{iconType}</span>{linkedSourceText}
                        </div>
                    }
                />
            </td>
        );
    };

    const sourceCell = props => {
        const { calculatedSensor } = props.dataItem;

        return (
            <td>
                {calculatedSensor ? 'Calculation' : 'Device Object' }
            </td>
        );
    };

    const timeStampCell = props => {
        const { dataItem, field, style, className } = props;
        const conditions = formatObj['timestamp'];
        let _className = '';
        const datatype = 'date';
        let zone = moment.tz.guess();
        let fd = moment(dataItem[field]).format('YYYY-MM-DD h:mm A');
        const timeDisplay = fd + ' ' + getTimeZoneAbbr(dataItem[field], zone);
        if (conditions && dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined) {
            _className = parseCondition(conditions, fd, datatype);
        }
        return (
            <td className={`${className} ${_className}`} style={style}>
                {timeDisplay}
            </td>
        );
    };

    const getStyle = (condition) => {
        if (!condition) {
            return '';
        }
        else if (condition.indexOf('Yellow') !== -1) {
            return 'yellow-cell';
        }
        else if (condition.indexOf('Green') !== -1) {
            return 'green-cell';
        }
        else if (condition.indexOf('Grey') !== -1) {
            return 'grey-cell';
        }
        else if (condition.indexOf('Red') !== -1) {
            return 'red-cell';
        }
        else return '';
    };

    const getBoolean = (val)=>{
        return String(val).toLowerCase() === 'true';
    };

    const parseCondition = (conditions, value, datatype) => {
        let style = '';
        if (datatype === 'numeric') {
            conditions.forEach(c => {
                if (c.operator === 'Greater Than') {
                    if (Number(value) > c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Less Than') {
                    if (Number(value) < c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (Number(value) === c.field1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Between') {
                    if ((Number(value) >= c.field1 && Number(value) <= c.field2) || (Number(value) <= c.field1 && Number(value) >= c.field2)) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else if (datatype === 'boolean') {
            conditions.forEach(c => {
                if (c.operator === 'Equals') {
                    if (getBoolean(value) === getBoolean(c.field1)) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not Equal') {
                    if (getBoolean(value) !== getBoolean(c.field1)) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else if (datatype === 'date') {
            conditions.forEach(c => {
                if (c.operator === 'Greater Than') {
                    if (new Date(value).getTime() > new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Less Than') {
                    if (new Date(value).getTime() < new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (new Date(value).getTime() === new Date(c.field1).getTime()) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Between') {
                    if ((new Date(value).getTime() >= new Date(c.field1).getTime() && new Date(value).getTime() <= new Date(c.field2).getTime()) ||
                    (new Date(value).getTime() <= new Date(c.field1).getTime() && new Date(value).getTime() >= new Date(c.field2).getTime())) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        else   if (datatype === 'string' || datatype === 'text') {
            conditions.forEach(c => {
                if (c.operator === 'Contains') {
                    if (value.indexOf(c.field1) !== -1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not contain') {
                    if (value.indexOf(c.field1) === -1) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Equals') {
                    if (value === c.field1 ) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Does not Equal') {
                    if (value !== c.field1 ) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Starts with') {
                    if (value.startsWith(c.field1 )) {
                        style = getStyle(c.condition);
                    }
                }
                else if (c.operator === 'Ends with') {
                    if (value.endsWith(c.field1 )) {
                        style = getStyle(c.condition);
                    }
                }
            });
        }
        return style;
    };

    const valueCell = props => {
        const { dataItem, field } = props;
        const conditions = formatObj[field];
        let className = '';
        const datatype = columnNames.filter(c => c.field === field)[0].filter;
        if (conditions && dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined) {
            className = parseCondition(conditions, dataItem[field], datatype);
        }
        return (
            <td style={{textTransform: 'capitalize'}} className={className} >
                {
                    (dataItem[field] !== null && dataItem[field] !== '' && dataItem[field] !== undefined) ?
                        dataItem[field].toString() === 'Poll Failure' ? dataItem[field].toString() :
                            datatype === 'numeric' ? parseFloat(dataItem[field]) : dataItem[field].toString() : 'No Data'
                }
            </td>
        );    
    };

    const fetchSensorDataForDelete = (sensorData) => {
        setSensor(sensorData);
        handleToggleDeleteSensorModal(true);
    };

    const fetchSensorPreviewData = async (sensorData) => {

        setDeviceObjects([]);
        if (sensorData.deviceId !== '00000000-0000-0000-0000-000000000000') {
            await fetchDeviceObjects(sensorData.deviceId);
        }
        setSensor(sensorData);
        setPreviewDataModalOpen(true);
    };


    const handleEditSensor = sensor => {
        setSelectedSensor(sensor);

        const queryValues = queryString.parse(history.location.search);
        queryValues.sensor = sensor.id;
        const queryValuesString = queryString.stringify(queryValues);

        const query = `?${queryValuesString}`;

        history.push({ pathname: '/v2/dashboard/system/sensor', search: query, state: { entityId: queryValues.system, sensorHistory: [...selectedSensors], ruleHistory: selectedRule, entityType: 'system' } });
    };

    const resetCalculation = async (sensorData) => {
        const options = {resetcalculatedsensor: true};
        await resetCalculatedSensor(sensorData.id, options);
    };

    const startValueChange = e => {
        setStartValue(e.target.value);
    };

    const onResetCalculationModal = (entityData) => {
        setResetCalculationModalOpen(true);
        setResetCalculationEntity(entityData);
    };

    const updateSensorRunTime = async () => {
        const queryValues = queryString.parse(history.location.search);
        let payload = {
            ...resetCalculationEntity,
            runtimeHours: Number(startValue)
        };
        const options = {resetcalculatedsensor: true};
        
        await updateSensor(payload.id, queryValues.system, activeNavSite.id, {}, payload, options);
        setResetCalculationModalOpen(false);
    };

    const actionsCell = props => {
        const { calculatedSensor, sensorType } = props.dataItem;
        const isRuntime = sensorType.name.toLowerCase().includes('total runtime');

        return (
            calculatedSensor ?
                <td className={props.className} style={props.style}>
                    <BobTableContextMenu
                        entityData={props.dataItem}
                        type={'CalculatedSensors'}
                        isRuntimeCalculation={calculatedSensor && isRuntime}
                        onDelete={(entityData) => {fetchSensorDataForDelete(entityData);}}
                        onPreviewSensorData={(entityData) => {fetchSensorPreviewData(entityData);}}
                        onResetCalculation={(entityData) => {resetCalculation(entityData);}}
                        onResetCalculationModal={(entityData) => {onResetCalculationModal(entityData);}}
                    />
                </td>
                :
                <td className={props.className} style={props.style}>
                    <BobTableContextMenu
                        entityData={props.dataItem}
                        onFetch={handleEditSensor}
                        hideSubscribe
                        onDelete={(entityData) => {fetchSensorDataForDelete(entityData);}}
                        onPreviewSensorData={(entityData) => {fetchSensorPreviewData(entityData);}}
                    />
                </td>
        );
    };

    const renderValueAxis = (ds) => {
        let axisCrossingValue = [];

        let axisMap = new Map();
        ds.forEach(item => {
            if (item.visible) {
                if (!axisMap.has(item.axis)) {
                    axisMap.set(item.axis, { min: item.min, max: item.max });
                }
                else {
                    let obj = axisMap.get(item.axis);
                    if (obj.min > item.min) {
                        obj.min = item.min;
                    }
                    if (obj.max < item.max) {
                        obj.max = item.max;
                    }
                    axisMap.set(item.axis, obj);
                }
            }
        });

        ds.forEach(item => {
            if (item.visible) {
                if (!axisCrossingValue.find(entry => entry.name === item.axis)) {
                    axisCrossingValue.push({
                        name:             item.axis,
                        presentationUnit: item.axis ? item.axis : '',
                        min:              axisMap.get(item.axis).min,
                        max:              axisMap.get(item.axis).max
                    });
                }
            }
        });
        setAxis(axisCrossingValue);
    };

    const renderAxisCrossingValue = () => {
        let axisCrossingValue = [];

        if (!isEmpty(numericDataSet)) {
            if (!numericDataSet[0].axis) {
                return [];
            }
        }

        numericDataSet.map(item =>
            axisCrossingValue.push(new Date(moment(dashboardEndTimeStamp).add(1, 'days')))
        );

        axisCrossingValue.pop();
        axisCrossingValue.push(0);

        return axisCrossingValue.reverse();
    };

    const renderDesiredInterval = () => {
        return (
            <div className={classes.DesiredIntervalContainer}>
                <label className={classes.IntervalLabel}>{`Interval - ${desiredInterval}`}</label>
            </div>
        );
    };

    const refreshOverview = async () => {
        await fetchEntitySensors(activeNavSite.id, queryValues.system);
    };

    const ColumnMenu = (props) => {

        const createConditionalFormat = () => {
            props.onCloseMenu();
            let formats = [];
            if (formatObj[props.column.field]) {
                formats = formatObj[props.column.field];
            }
            let col =columnNames.filter(c=>c.field === props.column.field);
            if (col && col.length >0) {
                setFormatType(col[0].filter);
            }
            setFormatList(JSON.parse(JSON.stringify(formats)));
            setFormatKey(props.column.field);
            setShowModal(true);
        };

        const clearColumnFormat = () => {
            props.onCloseMenu();
            let format = formatObj;
            if (format[props.column.field]) {
                delete format[props.column.field];
            }
            setFormatObj(format);
            setFormatList([]);
        };

        const clearTableFormat = () => {
            props.onCloseMenu();
            setFormatObj({});
            setFormatList([]);
        };

        const addCalculatedColumn = () => {
            setCurrentFormula(null);
            const colIndex = sensorGridRef.current._columns.find(c => c.field === props.column.field).orderIndex;
            if (!colIndex) {
                setFormulaColumnIndex(sensorGridRef.current._columns.length);
            }
            else {
                setFormulaColumnIndex(colIndex);
            }

            props.onCloseMenu();
            setFormulaCellModalOpen(true);
        };

        const editCalculatedColumn = () => {
            const editFormula = formulaColumns.find(f => f.fieldName === props.column.field);
            if (editFormula) {
                setCurrentFormula(editFormula);
                setFormulaCellModalOpen(true);
            }
            props.onCloseMenu();
        };

        const remomveCalculatedColumn = () => {
            const updatedColumns = columnNames.filter(c => c.field !== props.column.field);
            setColumnNames(updatedColumns);

            const updatedExportColumns = exportColumnNames.filter(c => c.field !== props.column.field);
            setExportColumnNames(updatedExportColumns);
            setFormulaGridColumns(updatedColumns);

            const currentFormulaList = _.cloneDeep(formulaColumns);
            const updatedColumnList = currentFormulaList.filter(c => c.fieldName !== props.column.field);
            setFormulaColumns(updatedColumnList);
            configuration.columns = updatedColumns;
            configuration.selectedFormulaColumns = updatedColumnList;
            setConfiguration(configuration);
            props.onCloseMenu();
        };

        return (
            <div>
                <div style={{width: 'auto'}} className={classes.BobActionMenuFormat}>
                    <button
                        onClick={createConditionalFormat} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${classes.BobActionFormatItem}`} tabIndex="0"
                        type="button"
                    >
                        <span className="MuiButton-label">  <i className={`fa fa-plus ${ classes.BobActionMenuIcon }`} />Conditional Formatting</span>
                    </button>
                    <button
                        onClick={clearColumnFormat} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${classes.BobActionFormatItem}`} tabIndex="0"
                        type="button"
                    >
                        <span className="MuiButton-label"><i className={`fas fa-redo-alt ${ classes.BobActionMenuIcon }`} />Clear Column Formatting</span>
                    </button>
                    <button
                        onClick={clearTableFormat} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${classes.BobActionFormatItem}`} tabIndex="0"
                        type="button"
                    >
                        <span className="MuiButton-label"><i className={`fas fa-redo-alt ${ classes.BobActionMenuIcon }`} />Clear Table Formatting</span>
                    </button>
                    {
                        columnNames.filter(c => c.filter === 'numeric').length > 1 ?
                            <button
                                onClick={addCalculatedColumn} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${ classes.BobActionFormatItem }`} tabIndex="0"
                                type="button"
                            >
                                <span className="MuiButton-label"><i className={`fas fa-columns ${ classes.BobActionMenuIcon }`} />Add Formula Column</span>
                            </button>
                            : null
                    }
                    {
                        props.isFormula ?
                            <button
                                onClick={editCalculatedColumn} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${ classes.BobActionFormatItem }`} tabIndex="0"
                                type="button"
                            >
                                <span className="MuiButton-label"><i className={`fa fa-edit ${ classes.BobActionMenuIcon }`} aria-hidden="true" />Edit Formula Column</span>
                            </button> : null
                    }
                    {
                        props.isFormula ?
                            <button
                                onClick={remomveCalculatedColumn} className={`MuiButtonBase-root MuiButton-root MuiButton-text ${classes.BobActionFormatItem}`} tabIndex="0"
                                type="button"
                            >
                                <span className="MuiButton-label"><i className={`fa fa-times ${ classes.BobActionMenuIcon }`} />Remove Formula Column</span>
                            </button>
                            : null
                    }
                </div>
            </div>
        );
    };

    const handleChangetabView = (tabView) => {
        const queryValues = queryString.parse(history.location.search);

        const { pathname } = history.location;

        if (tabView.viewParentId) {
            queryValues.viewChildId = tabView.key;
            queryValues.childId = tabView.viewParentId;
        } else {
            queryValues.childId = tabView.key;
        }

        const queryValueString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValueString}`);
    };

    const colors = ['#1337ff', '#ff3a2c', '#26dc2e', '#fdbf00', '#007eff', '#28b4c8', '#aa46be', '#ff10f8', '#ff5c69', '#d94c92', '#cc0000', '#a5502b', '#5c2aba'];

    const refreshGrid = async () => {
        if (view === 'rawdata') {
            setRefreshRawDataGrid(true);
            setRefreshTab(view);
        }
        else {
            setRefreshTab(view);

            if (view === 'overview') {
                await fetchEntitySensors(activeNavSite.id, queryValues.system);

                let updatedSensors = [...tableSensors];

                setTableSensors(updatedSensors);
                setRefreshTab('');
            }
        }
    };

    const onColumnReorder = e => {
        const orderedColumns = e.columns.sort((a, b) => a.orderIndex - b.orderIndex).map((column, index) => {
            return {
                name:   column.title,
                title:  column.title,
                field:  column.field,
                filter: column.filter,
                locked: column.locked ? column.locked : false
            };
        });
        setExportColumnNames(orderedColumns);
        setConfiguration({ ...configuration, columns: orderedColumns });
    };

    const onSensorGridDataStateChange = e => {
        if (activeConfiguration && activeConfiguration.viewData) {
            if (e.dataState.filter !== activeConfiguration.viewData.filter) {
                setConfiguration({...configuration, filter: e.dataState.filter});
            }
        }
        setSensorGridDataState(e.dataState);
    };

    const onOverviewGridDataStateChange = e => {
        setOverviewGridTake(e.dataState.take);
        setOverviewGridDataState(e.dataState);
    };

    const aggregateFooterCell = props => {
        const field = props.field || '';
        const filteredData = _.cloneDeep(kendoProcess(sensorGridData, sensorGridDataState));
        const column = sensorGridRef?.current?._columns.find(c => c.field === field);
        const columnType = column?.filter;
        let isRuntimeColumn = false;
        if (column && column.title.toLowerCase().includes('runtime') && aggregateType === 'Runtime') {
            isRuntimeColumn = true;
        }

        return (
            <SensorScoreAggregateFooterCell
                aggregateType={aggregateType}
                className={props.className}
                colSpan={props.colSpan}
                columnType={columnType}
                excelExport={false}
                filteredData={filteredData}
                field={field}
                style={props.style}
                isRuntimeColumn={isRuntimeColumn}
            />
        );
    };

    const ExcelExportFooterCell = props => {
        const field = props.column.field || '';
        const filteredData = _.cloneDeep(kendoProcess(sensorGridData, sensorGridDataState));
        const column = sensorGridRef?.current?._columns.find(c => c.field === field);
        const columnType = column?.filter;
        let isRuntimeColumn = false;
        if (column && column.title.toLowerCase().includes('runtime') && aggregateType === 'Runtime') {
            isRuntimeColumn = true;
        }

        return (
            <SensorScoreAggregateFooterCell
                aggregateType={aggregateType}
                columnType={columnType}
                excelExport={true}
                filteredData={filteredData}
                field={field}
                isRuntimeColumn={isRuntimeColumn}
            />
        );
    };

    const BuildDeviceObjectCellFilter = props => {
        return DeviceObjectCellFilter(props, selectedBooleanFilter, setSelectedBooleanFilter);
    };

    const clearSensorGridFilter = filter => {
        setSensorGridDataState({...sensorGridDataState, filter: filter ? filter : initialDataStateFilter});
    };

    return (
        <React.Fragment>
            <div style={{position: 'absolute',width: 0,height: 0}}>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                    <defs>
                        <pattern
                            id="pattern2" width="3" height="3"
                            patternTransform="rotate(45 0 0)" patternUnits="userSpaceOnUse"
                        >
                            <line
                                x1="0" y1="0" x2="0"
                                y2="10" style={{stroke: '#8d8d8d',strokeWidth: 1}}
                            />
                        </pattern>
                    </defs>
                </svg>
            </div>
            {
                view === 'overview' ?
                    <div ref={overviewGridDivRef} className={classes.Table}>
                        <div className={classes.TableOverviewContainerHead}>
                            <div className={classes.SelectContainer}>
                                <TabViewSelector
                                    overviewPage={'system'}
                                    activeView={view}
                                    activeTab={activeTab}
                                    handleChangeView={handleChangetabView}
                                />
                            </div>
                            {renderActionItem()}
                        </div>
                        <style>
                            { kendoGridInlineStyling }
                        </style>
                        <Grid
                            ref={overviewGridRef}
                            className={classes.SensorGrid}
                            data={kendoProcess(tableSensors, overviewGridDataState)}
                            {...overviewGridDataState}
                            sortable={{
                                mode: 'multiple'
                            }}
                            filterable={workbookModeEnabled}
                            pageable={pageable}
                            reorderable
                            onDataStateChange={onOverviewGridDataStateChange}
                        >
                            {
                                bobLoading.includes('EntitySensors') || isEmpty(sensorsMeta) ?
                                    <GridNoRecords>
                                        Loading sensors
                                    </GridNoRecords>
                                    :
                                    null
                            }
                            <Column
                                field="name"
                                title="Name"
                                width={overviewNameColumnWidth}
                            />
                            <Column field="sensorType.name" title="Sensor Type" width="350px" />
                            <Column field="displayDataType" title="Data Type" width="200px" />
                            <Column
                                field="rawUnitDisplay"
                                title="Units"
                                width="150px"
                            />
                            <Column
                                field="calculatedSensor"
                                title="Source"
                                width="250px"
                                filter={'boolean'}
                                filterCell={BuildDeviceObjectCellFilter}
                                cell={sourceCell}
                            />
                            <Column
                                field="linkedSourceText"
                                title="Source Name"
                                width="400px"
                                cell={sourceNameCell}
                            />
                            <Column
                                field=""
                                title=""
                                width={75}
                                locked={true}
                                sortable={false}
                                filterable={false}
                                cell={actionsCell}
                            />
                        </Grid>
                        {
                            deleteSensorModalOpen ?
                                <BobModal
                                    title={'Delete Entity'}
                                    hidebuttons={true}
                                    isRemoveFooter={true}
                                    onClose={() => {
                                        handleToggleDeleteSensorModal(false);
                                    }}
                                >
                                    <DeleteSensorModal
                                        client={queryValues.client}
                                        site={queryValues.site}
                                        refreshOverview={refreshOverview}
                                        sensor={sensor}
                                        onClose={() => { handleToggleDeleteSensorModal(false); }}
                                    />
                                </BobModal> : ''
                        }
                        {
                            previewDataModalOpen ?
                                <BobModal
                                    title={`Preview ${sensor.name} Data`}
                                    hidebuttons={true}
                                    isRemoveFooter={true}
                                    onClose={() => setPreviewDataModalOpen(false)}
                                >
                                    <PreviewSensorModal
                                        sensor={sensor}
                                        onClose={() => setPreviewDataModalOpen(false)}
                                    />
                                </BobModal>
                                : null
                        }
                        {
                            resetCalculationModalOpen ?
                                <BobModal
                                    title={'Runtime'}
                                    hidebuttons={true}
                                    isRemoveFooter={true}
                                    onClose={() => {
                                        setResetCalculationModalOpen(false);
                                        setStartValue(0);
                                    }}
                                >
                                    <React.Fragment>
                                        <div className={classes.FormField}>
                                            <TextField
                                                id="startValue"
                                                name="startValue"
                                                type="number"
                                                variant={'outlined'}
                                                size="small"
                                                label={<span>Start Value <span className={classes.Required}> *</span></span>}
                                                value={startValue}
                                                onChange={(e) => startValueChange(e)}
                                                inputProps={{
                                                    min: 0
                                                }}
                                            />
                                        </div>
                                        <BobCancelButton
                                            className={classes.Buttons}
                                            onClick={() => {
                                                setResetCalculationModalOpen(false);
                                                setStartValue(0);
                                            }}
                                            label={'Cancel'}
                                        />
                                        <BobConfirmButton
                                            className={classes.Buttons}
                                            disabled={startValue && startValue >= 0 ? false : true}
                                            onClick={() => updateSensorRunTime()}
                                            label={'Update'}
                                            iconSize={15}
                                        />
                                    </React.Fragment>
                                </BobModal> : ''
                        }
                    </div>
                    : null
            }
            {
                view === 'sensorgraph' ?
                    <React.Fragment>
                        <div className={classes.TableContainerHead}>
                            <div className={classes.SelectContainer}>
                                <TabViewSelector
                                    overviewPage={'system'}
                                    activeView={view}
                                    activeTab={activeTab}
                                    handleChangeView={handleChangetabView}
                                />
                            </div>
                            <BobChartTypeMenu chartType={chartType} setChartType={setChartTypeProps} />
                            {renderDesiredInterval()}
                            {renderActionItem()}
                        </div>
                        <div className={classes.SensorPanel}>
                            {
                                isEmpty(selectedRuleSensors) && isEmpty(selectedWeatherSensors) ?
                                    <NoSelectedSensorsScreen
                                        message="Please select a Sensor from the dropdown list above to load the data"
                                        height={sensorGraphHeight}
                                    />
                                    :
                                    <Chart
                                        style={{
                                            height: sensorGraphHeight
                                        }}
                                        ref={chart}
                                        onLegendItemClick={onLegendItemClick}
                                        seriesColors={colors}
                                        pannable={{ lock: 'y' }}
                                        zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}
                                    >
                                        <ChartTitle text={!isEmpty(selectedRule) ? `Sensor - ${selectedRule.ruleName}` : 'Sensor'} align="left" font="12pt sans-serif" />
                                        <ChartTooltip
                                            shared={true} render={sharedTooltipRender} background="#FFFFFF"
                                            opacity={.95}
                                        />
                                        {
                                            !isEmpty(ganttDs) ?
                                                <ChartPanes>
                                                    <ChartPane name="top" />
                                                    <ChartPane name="bottom" />
                                                </ChartPanes>
                                                :
                                                <ChartPanes>
                                                    <ChartPane name="top" />
                                                </ChartPanes>
                                        }
                                        {
                                            !isEmpty(ganttDs) ?
                                                <ChartCategoryAxis>
                                                    <ChartCategoryAxisItem
                                                        baseUnit="minutes"
                                                        baseUnitStep={desiredInterval}
                                                        pane="top"
                                                        maxDivisions={12}
                                                        labels={{ visible: isEmpty(ganttDs) ? true : false }}
                                                        axisCrossingValue={renderAxisCrossingValue()}
                                                    />
                                                    <ChartCategoryAxisItem
                                                        baseUnit="minutes"
                                                        baseUnitStep={desiredInterval}
                                                        pane="bottom"
                                                        maxDivisions={12}
                                                    />
                                                </ChartCategoryAxis>
                                                :
                                                <ChartCategoryAxis>
                                                    <ChartCategoryAxisItem
                                                        baseUnit="minutes"
                                                        baseUnitStep={desiredInterval}
                                                        pane="top"
                                                        maxDivisions={12}
                                                        labels={{ visible: isEmpty(ganttDs) ? true : false }}
                                                        axisCrossingValue={renderAxisCrossingValue()}
                                                    />
                                                </ChartCategoryAxis>
                                        }
                                        <ChartValueAxis>
                                            <ChartValueAxisItem labels={{ visible: true, format: '#.00' }} />
                                        </ChartValueAxis>
                                        <ChartLegend visible={true} position="top" orientation="horizontal" />
                                        <ChartSeries>
                                            {numericDataSet.map((item, index) => (
                                                <ChartSeriesItem
                                                    missingValues="gap"
                                                    axis={item.axis}
                                                    type={chartType === 'Line' ? 'line' : 'column'}
                                                    categoryField="timestamp"
                                                    name={item.sensorName}
                                                    key={item.sensorId}
                                                    dashType={item.lineType}
                                                    visible={item.visible}
                                                    // eslint-disable-next-line react/style-prop-object
                                                    style="smooth"
                                                    markers={{
                                                        visible: dashboardIsCurrentTimeStamp ? true : false, size: 4, background: colors[index]
                                                    }}
                                                    data={item.data}
                                                    field="convertedValue"
                                                />
                                            ))}
                                            <ChartSeriesItem
                                                missingValues="gap"
                                                axis="Fault"
                                                color="red"
                                                opacity={0.2}
                                                type="area"
                                                name="Fault"
                                                categoryField="timestamp"
                                                key="Fault"
                                                visibleInLegend={false}
                                                data={overlayData}
                                                field="value"
                                            />
                                            {ganttDs.map((item, i) => (
                                                <ChartSeriesItem
                                                    axis={'bottom'}
                                                    markers={{ visible: (item.dataColor === '#ff6d01' || item.dataColor === '#6f6f6f') ?true:false, size: 4, background: `${item.dataColor}`}}
                                                    type="line"
                                                    width={6}
                                                    categoryField="timestamp"
                                                    name={item.sensorName}
                                                    key={`${item.sensorId}-${i}`}
                                                    visibleInLegend={false}
                                                    color={item.dataColor}
                                                    data={item.data}
                                                    field="convertedValue"
                                                />
                                            ))}
                                        </ChartSeries>
                                        <ChartValueAxis>
                                            {axis.map((item, idx) => (
                                                <ChartValueAxisItem
                                                    key={idx}
                                                    name={item.name}
                                                    title={{ text: item.presentationUnit }}
                                                    pane="top"
                                                    narrowRange={true}
                                                    majorGridLines={
                                                        { width: 1, dashType: 'dot' }
                                                    }
                                                />
                                            ))}
                                            <ChartValueAxisItem
                                                key={'Fault'}
                                                name={'Fault'}
                                                pane="top"
                                                min={0}
                                                max={1}
                                                labels={{
                                                    visible: false,
                                                }}
                                            />
                                            <ChartValueAxisItem
                                                key={999}
                                                name="bottom"
                                                pane="bottom"
                                                line={{ visible: true }}
                                                majorGridLines={
                                                    { width: 1, dashType: 'dot' }
                                                }
                                                min={ganttAxisMin}
                                                majorUnit={1}
                                                max={ganttAxisMax}
                                                labels={{ content: labelContent, visible: true }}
                                            />

                                        </ChartValueAxis>
                                    </Chart>
                            }
                        </div>
                    </React.Fragment>
                    : null
            }
            {
                view === 'sensorgrid' ?
                    <React.Fragment>
                        <div className={classes.TableContainerHead}>
                            <div className={classes.SelectContainer}>
                                <TabViewSelector
                                    overviewPage={'system'}
                                    activeView={view}
                                    activeTab={activeTab}
                                    handleChangeView={handleChangetabView}
                                />
                            </div>
                            {renderDesiredInterval()}
                            {renderActionItem()}
                        </div>
                        <div className={classes.SensorPanel}>
                            <ExcelExport
                                data={filterBy(sensorGridData, sensorGridDataState.filter)} 
                                ref={_export}
                            >
                                {
                                    exportColumnNames.map((column, index) => (
                                        <ExcelExportColumn
                                            key={ index }
                                            field={ column.field }
                                            title={ column.name }
                                            locked={column.locked ? column.locked : false}
                                            filter={column.filter}
                                            footer={aggregateType !== 'None' ? ExcelExportFooterCell : null}
                                        />
                                    ))
                                }

                            </ExcelExport>
                            {
                                isEmpty(selectedRuleSensors) && isEmpty(selectedWeatherSensors) ?
                                    <NoSelectedSensorsScreen
                                        message="Please select a Sensor from the dropdown list above to load the data"
                                        height={sensorGraphHeight}
                                    />
                                    :
                                    <React.Fragment>
                                        <style>
                                            { kendoGridInlineStyling }
                                            {
                                                `.k-toolbar {
                                                    order: 1;
                                                    border-top: inset 1px rgba(0, 0, 0, 0.12);
                                                    max-height: 5.8rem;
                                                }
                                                `
                                            }
                                        </style>
                                        <Grid
                                            ref={sensorGridRef}
                                            sortable={{
                                                mode: 'multiple'
                                            }}
                                            className={classes.SensorGrid}
                                            data={kendoProcess(sensorGridData, sensorGridDataState)}
                                            {...sensorGridDataState}
                                            filterable={workbookModeEnabled}
                                            reorderable
                                            onColumnReorder={onColumnReorder}
                                            onDataStateChange={onSensorGridDataStateChange}
                                        >
                                            {
                                                workbookModeEnabled ?
                                                    <GridToolbar>
                                                        <FilterPanel
                                                            title={'Sensor Filter Builder'}
                                                            filter={sensorGridDataState.filter}
                                                            filterText={sensorGridFilterText}
                                                            fields={sensorGridFields}
                                                            columns={columnNames}
                                                            setFilter={clearSensorGridFilter}
                                                            setFilterText={setSensorGridFilterText}
                                                        />
                                                    </GridToolbar>
                                                    : null
                                            }
                                            {
                                                bobLoading.includes('SensorData') ?
                                                    <GridNoRecords>
                                                        Loading sensor data
                                                    </GridNoRecords>
                                                    :
                                                    null
                                            }
                                            {
                                                columnNames.map((column, index) => (
                                                    <Column
                                                        key={ index }
                                                        locked={ index === 0 }
                                                        reorderable={index !== 0}
                                                        field={column.field}
                                                        title={column.name}
                                                        width={225}
                                                        columnMenu={(props) => (
                                                            <ColumnMenu
                                                                {...props}
                                                                isFormula={column.isFormula ? column.isFormula : false}
                                                            />
                                                        )}
                                                        filter={column.filter}
                                                        cell={index === 0 ? timeStampCell : valueCell}
                                                        footerCell={aggregateType !== 'None' ? aggregateFooterCell : null}
                                                    />
                                                ))
                                            }
                                        </Grid>
                                    </React.Fragment>
                            }
                        </div>
                    </React.Fragment>
                    : null
            }
            {
                view === 'scoregraph' ?
                    <React.Fragment>
                        <div className={classes.Table}>
                            <div className={classes.TableContainerHead}>
                                <div className={classes.SelectContainer}>
                                    <TabViewSelector
                                        overviewPage={'system'}
                                        activeView={view}
                                        activeTab={activeTab}
                                        handleChangeView={handleChangetabView}
                                    />
                                </div>
                                <div className={classes.RuleFilterContainer}>
                                    <GraphViewSelector chartType={scoreChartType} setChartType={setScoreChartTypeProps} />
                                </div>
                                <BobChartTypeMenu chartType={chartType} setChartType={setChartType} />
                                {renderDesiredInterval()}
                                {renderActionItem()}
                            </div>
                            <ScoresPanel
                                propsFunc={propFunc}
                                axes={axes}
                                chartType={chartType}
                                scoreChartType={scoreChartType}
                                isActive={view === 'scoregraph'}
                                activeConfiguration={activeConfiguration}
                                configuration={configuration}
                                setConfiguration={setConfiguration}
                                gridDataState={ruleGraphGridDataState}
                                gridFilterText={ruleGraphGridFilterText}
                                gridFilter={ruleGraphGridFilter}
                                gridFields={ruleGraphGridFields}
                                setGridDataState={setRuleGraphGridDataState}
                                setGridFilterText={setRuleGraphGridFilterText}
                                setGridFilter={setRuleGraphGridFilter}
                                setGridFields={setRuleGraphGridFields}
                            />
                        </div>
                    </React.Fragment>
                    :
                    null
            }
            {
                view === 'scoregrid' ?
                    <React.Fragment>
                        <div className={classes.Table}>
                            <div className={classes.TableContainerHead}>
                                <div className={classes.SelectContainer}>
                                    <TabViewSelector
                                        overviewPage={'system'}
                                        activeView={view}
                                        activeTab={activeTab}
                                        handleChangeView={handleChangetabView}
                                    />
                                </div>
                                {renderDesiredInterval()}
                                {renderActionItem()}
                            </div>
                            <ScoreGrid
                                aggregateType={aggregateType}
                                axes={ axes }
                                activeConfiguration={activeConfiguration}
                                refresh={refresh}
                                isActive={view === 'scoregrid'}
                                configuration={configuration}
                                ruleGridDataState={ruleGridDataState}
                                ruleGridFields={ruleGridFields}
                                ruleGridFilter={ruleGridFilter}
                                ruleGridFilterFields={ruleGridFields}
                                ruleGridFilterText={ruleGridFilterText}
                                setAggregateType={setAggregateType}
                                setConfiguration={setConfiguration}
                                scoreGridDataState={scoreGridDataState}
                                scoreGridFields={scoreGridFields}
                                scoreGridFilter={scoreGridFilter}
                                scoreGridFilterText={scoreGridFilterText}
                                setRuleGridDataState={setRuleGridDataState}
                                setRuleGridFilterText={setRuleGridFilterText}
                                setRuleGridFilter={setRuleGridFilter}
                                setRuleGridFields={setRuleGridFields}
                                setScoreGridDataState={setScoreGridDataState}
                                setScoreGridFields={setScoreGridFields}
                                setScoreGridFilter={setScoreGridFilter}
                                setScoreGridFilterText={setScoreGridFilterText}
                            />
                        </div>
                    </React.Fragment>
                    :
                    null
            }
            {
                view === 'rawdata' ?
                    <React.Fragment>
                        <div className={classes.Table}>
                            <div className={classes.TableContainerHead}>
                                <div className={classes.SelectContainer}>
                                    <TabViewSelector
                                        overviewPage={'equipment'}
                                        activeTab={activeTab}
                                        activeView={view}
                                        handleChangeView={handleChangetabView}
                                    />
                                </div>
                                {renderActionItem()}
                            </div>
                            <div className={classes.RawDataContainer}>
                                <div className={classes.RuleScoreGrid}>
                                    <RulesScoreGrid 
                                        refreshRuleGrid={refreshRawDataGrid}
                                        rules={rules}
                                        selectedSystem={system}
                                        selectedEquipmentRule={selectedSystemRule}
                                        setRules={setRules}
                                        setSelectedEquipmentRule={setSelectedSystemRule}
                                    />
                                </div>
                                <div className={classes.RawDataGrid}>
                                    <RawDataTable
                                        isActive={view === 'rawdata'}
                                        activeSite={activeNavSite}
                                        activeConfiguration={activeConfiguration}
                                        activeSystem={system}
                                        configuration={configuration}
                                        exportRawData={exportRawData}
                                        gridDataState={ruleGraphGridDataState}
                                        gridFilterText={ruleGraphGridFilterText}
                                        gridFilter={ruleGraphGridFilter}
                                        gridFields={ruleGraphGridFields}
                                        healthscoreRawData={healthscoreRawData}
                                        healthscoreRawDataMeta={healthscoreRawDataMeta}
                                        refreshRawDataGrid={refreshRawDataGrid}
                                        selectedEquipmentRule={selectedSystemRule}
                                        setConfiguration={setConfiguration}
                                        setFormulaGridColumns={setFormulaGridColumns}
                                        setExportRawData={setExportRawData}
                                        setGridDataState={setRuleGraphGridDataState}
                                        setGridFilterText={setRuleGraphGridFilterText}
                                        setGridFilter={setRuleGraphGridFilter}
                                        setGridFields={setRuleGraphGridFields}
                                        setRefreshRawDataGrid={setRefreshRawDataGrid}
                                        setSelectedEquipmentRule={setSelectedSystemRule}
                                        viewKey={viewKey}
                                    />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    :
                    null
            }
            {
                view === 'configuration' ?
                    <div className={classes.Table}>
                        <div className={classes.TableOverviewContainerHead}>
                            <div className={classes.SelectContainer}>
                                <TabViewSelector
                                    overviewPage={'system'}
                                    activeView={view}
                                    activeTab={activeTab}
                                    handleChangeView={handleChangetabView}
                                />
                            </div>
                            {renderDesiredInterval()}
                            {renderActionItem()}
                        </div>
                        <SensorConfigurationView
                            activeConfiguration={activeConfiguration}
                            configuration={configuration}
                            handleChangeView={handleChangetabView}
                            sensors={sensors}
                            setAxes={setAxes}
                            setConfiguration={setConfiguration}
                        />
                    </div>
                    :
                    null

            }
            {
                bobLoading.includes('SaveViewAndConfiguration') || bobLoading.includes('fetchConfigurations') || bobLoading.includes('UpdateViewAndConfiguration')
                || bobLoading.includes('SensorData') || bobLoading.includes('EntitySensors') || bobLoading.includes('UpdateOrDeleteViewAndConfiguration') || isEmpty(sensorsMeta) ?
                    <BobLoadingMask />
                    :
                    null
            }
            {showModal ?
                <ConditionalFormatModal
                    open={showModal}
                    formatList ={formatList}
                    formatKey = {formatKey}
                    fieldType={formatType}
                    addItem={addItem}
                    removeItem={removeItem}
                    updateFormat={updateFormat}
                    submitFormat={handleSubmit}
                    close={handleClose}
                /> : ''
            }
            {
                exportModalOpen ?
                    <ExportDataModal
                        entity={activeNavEquipment}
                        setExportModalOpen={setExportModalOpen}
                        isExportRawData={true}
                        tabView={view}
                        selectedRuleSensors={selectedRuleSensors}
                        selectedRule={selectedRule}
                    /> : ''
            }
            {
                formulaCellModalOpen ?
                    <FormulaGridColumnModal
                        cellIndex={formulaColumnIndex}
                        columnList={columnNames}
                        formula={currentFormula}
                        setFormulaFormIsOpen={setFormulaCellModalOpen}
                        setFormulaValues={setFormulaValues}
                        title={currentFormula ? 'Edit Formula' : 'Create Formula'}
                    />
                    : null
            }
        </React.Fragment>
    );
};

SensorPanel.defaultProps = {
    clearEntitySensorData: () => { },
    entitySensorData:      [],
    isActive:              false
};

SensorPanel.propTypes = {
    clearEntitySensorData: func,
    entitySensorData:      array,
    isActive:              bool
};

const mapStateToProps = state => {
    return {
        activeConfiguration:         state.configurationData.activeConfiguration,
        activeNavCompany:            state.bob.activeNavCompany,
        activeNavEquipment:          state.bob.activeNavEquipment,
        activeNavSite:               state.bob.activeNavSite,
        allSensors:                  state.bob.allSensors,
        allSensorsMeta:              state.bob.allSensorsMeta,
        bobLoading:                  state.bob.bobLoading,
        companyInfo:                 state.companyInfo,
        currentUser:                 state.currentUser,
        dashboardEndTimeStamp:       state.dashboard.dashboardEndTimeStamp,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        dashboardStartTimeStamp:     state.dashboard.dashboardStartTimeStamp,
        desiredInterval:             state.dashboard.desiredInterval,
        entityScoringData:           state.bob.entityScoringData,
        entitySensorData:            state.bob.entitySensorData,
        faultOverlay:                state.bob.faultOverlay,
        healthscoreRawData:          state.dashboard.healthscoreRawData,
        healthscoreRawDataMeta:      state.dashboard.healthscoreRawDataMeta,
        isClearAppliedConfiguration: state.configurationData.isClearAppliedConfiguration,
        newConfiguration:            state.configurationData.newConfiguration,
        redirection:                 state.configurationData.redirection,
        rawUnits:                    state.architect.rawUnits,
        selectedRule:                state.dashboard.selectedRule,
        selectedRuleSensors:         state.dashboard.selectedRuleSensors,
        selectedSensors:             state.dashboard.selectedSensors,
        selectedWeatherSensors:      state.dashboard.selectedWeatherSensors,
        sensors:                     state.bob.sensors,
        sensorsMeta:                 state.bob.sensorsMeta,
        updateConfigurationData:     state.configurationData.updateConfigurationData,
        workbookModeEnabled:         state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...BobActions,
    ...ConfigurationActions,
    ...DashboardActions,
    ...DeviceActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SensorPanel));
